const remark = require('remark');
const remarkHtml = require('remark-html');
const { sanitize } = require('./rehype-sanitize');

// use removeWrappingPTag option when you want to remove
// The <p> tag is a semantic element that represents a paragraph. The more accessible way to handle this is to use the <span> or no tag instead.

const toHtml = (markdown, { removeWrappingPTag = true } = {}) => {
  let html = remark().use(remarkHtml, { sanitize: false }).processSync(markdown).toString();

  if (removeWrappingPTag) {
    html = html.replace('<p>', '').replace('</p>', '');
  }

  return html;
};

module.exports = {
  toHtmlSanitize: (markdown, options) => sanitize(toHtml(markdown, options))
};
